import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import { createHead } from '@vueuse/head'
import VueGtag from 'vue-gtag-next'
import Paginate from 'vuejs-paginate-next'
import ElementPlugin from './plugins/element'
import { createMq } from './plugins/mq'

const app = createApp(App)

app.use(createHead())
app.config.globalProperties.axios = axios
app.config.globalProperties.$axios = axios

app.use(createMq({
  breakpoints: { sp: 959, pc: 960 },
  defaultBreakpoint: 'sp'
}))
app.use(ElementPlugin)

app.component('vue-paginate', Paginate)
app.use(router)
app.use(VueGtag, {
  property: {
    id: 'G-T0G0S97QF7'
  }
})

app.mount('#app')
